// extracted by mini-css-extract-plugin
module.exports = {"Media":"Media_Media__1REvR","Media__content":"Media_Media__content__2ZoV8","Image":"Media_Image__1Bjhg","Image__content":"Media_Image__content__1rien"};